import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const REDIRECT_SECONDS = 5;

export const ModalVerificationSuccess = ({ isOpen, onRedirect }) => {
    const [secondsLeft, setSecondsLeft] = useState(REDIRECT_SECONDS);

    useEffect(() => {
        if (!isOpen) {
            setSecondsLeft(REDIRECT_SECONDS);
            return undefined;
        }

        const intervalId = setInterval(() => {
            setSecondsLeft((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalId);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(intervalId);
    }, [isOpen]);

    useEffect(() => {
        if (isOpen && secondsLeft === 0) {
            onRedirect();
        }
    }, [isOpen, secondsLeft, onRedirect]);

    return (
        <Modal isOpen={isOpen} toggle={onRedirect} centered size='md' className='close-circle'>
            <ModalHeader toggle={onRedirect} className='justify-content-center border-0 pb-0' />
            <ModalBody className='text-center'>
                <p className='mb-4'>
                    User verification successful. You can now access the portal through the log in button. You'll be redirected in {secondsLeft} second{secondsLeft > 1 && 's'}.
                </p>
            </ModalBody>
        </Modal>
    );
};
